export var ModuleType;
(function (ModuleType) {
    ModuleType["SOCIAL_PLANNER"] = "social_planner";
    ModuleType["BLOGS"] = "blog";
    ModuleType["FUNNELS"] = "funnel";
    ModuleType["WEBSITES"] = "website";
    ModuleType["EMAIL_BUILDER"] = "email_builder";
    ModuleType["MEDIA_LIBRARY"] = "media_library";
})(ModuleType || (ModuleType = {}));
export var SubType;
(function (SubType) {
    SubType["INTRO"] = "intro";
    SubType["OUTLINE"] = "outline";
    SubType["SECTION"] = "section";
    SubType["HEADLINE"] = "headline";
    SubType["SUB_HEADLINE"] = "sub_headline";
    SubType["PARAGRAPH"] = "paragraph";
    SubType["BULLET_LIST"] = "bullet_list";
    SubType["SUBJECT"] = "subject";
    SubType["BODY"] = "body";
    SubType["CTA"] = "cta";
})(SubType || (SubType = {}));
export const SubTypeLabel = {
    intro: 'generateContentModal.typeOptions.introduction',
    outline: 'generateContentModal.typeOptions.outline',
    section: 'generateContentModal.typeOptions.section',
};
export var Context;
(function (Context) {
    Context["PROMOTIONAL"] = "promotional email";
    Context["INTRODUCTION"] = "introduction email";
    Context["COUPON_DISCOUNT"] = "coupon/discount email";
    Context["RECURRING_NEWSLETTER"] = "recurring email newsletter";
    Context["TESTIMONIAL"] = "testimonial email";
    Context["COLD_OUTREACH"] = "cold outreach email";
    Context["CONTENT_GIVEAWAY_EMAIL"] = "content/giveaway email";
    Context["OTHER"] = "other";
})(Context || (Context = {}));
export var ContentAITone;
(function (ContentAITone) {
    ContentAITone["FUNNY"] = "funny";
    ContentAITone["CASUAL"] = "casual";
    ContentAITone["EXCITED"] = "excited";
    ContentAITone["PROFESSIONAL"] = "professional";
    ContentAITone["WITTY"] = "witty";
    ContentAITone["SARCASTIC"] = "sarcastic";
    ContentAITone["FEMININE"] = "feminine";
    ContentAITone["MASCULINE"] = "masculine";
    ContentAITone["BOLD"] = "bold";
    ContentAITone["DRAMATIC"] = "dramatic";
    ContentAITone["GRUMPY"] = "grumpy";
    ContentAITone["SECRETIVE"] = "secretive";
    ContentAITone["RESPECTFUL"] = "respectful";
    ContentAITone["PERSUASIVE"] = "persuasive";
})(ContentAITone || (ContentAITone = {}));
export const FormFieldTitle = {
    title: 'generateContentModal.contentTitle',
    description: 'generateContentModal.description',
    keywords: 'generateContentModal.addKeywords',
    tone: 'generateContentModal.writingTone',
    numberOfVariations: 'generateContentModal.numberOfVariations',
    subType: 'generateContentModal.type',
    emailContext: 'generateContentModal.context',
};
export var FormFieldNames;
(function (FormFieldNames) {
    FormFieldNames["TITLE"] = "title";
    FormFieldNames["DESCRIPTION"] = "description";
    FormFieldNames["KEYWORDS"] = "keywords";
    FormFieldNames["TONE"] = "tone";
    FormFieldNames["NUMBER_OF_VARIATIONS"] = "numberOfVariations";
    FormFieldNames["SUB_TYPE"] = "subType";
    FormFieldNames["ADDITIONAL"] = "additional";
    FormFieldNames["CONTEXT"] = "emailContext";
    FormFieldNames["PRESET"] = "preset";
})(FormFieldNames || (FormFieldNames = {}));
